
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/smart-suppression",
      function () {
        return require("private-next-pages/ai-decisioning/smart-suppression.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/smart-suppression"])
      });
    }
  